'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { Notification } from '../Notification/Notification.js';
import { useMergedRefs } from '../../hooks/index.js';
export const UtilityNavItem = React.forwardRef((_a, ref) => {
    var { meta, className, children, text, href, iconName, hideText, notificationText, notificationScreenReaderText, role } = _a, other = __rest(_a, ["meta", "className", "children", "text", "href", "iconName", "hideText", "notificationText", "notificationScreenReaderText", "role"]);
    const [isActive, setIsActive] = React.useState(false);
    const ownRef = React.useRef(null);
    const utilityNavItemRef = useMergedRefs(ref, ownRef);
    const TagName = createTagName();
    const togglePanel = () => {
        setIsActive(!isActive);
    };
    React.useEffect(() => {
        document.addEventListener('mousedown', handleOnClickOutside, false);
        document.addEventListener('touchstart', handleOnClickOutside, false);
        return () => {
            document.removeEventListener('mousedown', handleOnClickOutside, false);
            document.removeEventListener('touchstart', handleOnClickOutside, false);
        };
    }, []);
    const handleOnClickOutside = (event) => {
        if (ownRef.current &&
            !ownRef.current.contains(event.target)) {
            setIsActive(false);
        }
    };
    function createTagName() {
        if (href) {
            return 'a';
        }
        return 'button';
    }
    const componentClassName = classnames('sparky-c-utility-nav__item', className, {
        'sparky-is-active': isActive === true,
    });
    return (_jsxs("li", Object.assign({ className: componentClassName, ref: utilityNavItemRef, role: role }, other, { children: [_jsxs(TagName, Object.assign({ className: "sparky-c-utility-nav__link", href: href, onClick: togglePanel, "aria-expanded": !href && children ? isActive : undefined }, { children: [iconName && (_jsx(Icon, { className: "sparky-c-utility-nav__icon", "aria-hidden": "true", focusable: false, name: iconName, size: "xl" })), _jsxs("div", Object.assign({ className: classnames('sparky-c-utility-nav__text', 'sparky-u-typography-preset-8-bold', {
                            'sparky-u-is-vishidden': hideText,
                        }) }, { children: [meta && _jsx("span", Object.assign({ className: "sparky-c-utility-nav__meta" }, { children: meta })), text] })), children && (_jsx(Icon, { "aria-hidden": "true", focusable: false, name: "chevron-down", className: "sparky-c-utility-nav__icon-after" })), notificationText && (_jsx(Notification, { className: "sparky-c-utility-nav__item-notification", text: notificationText, screenReaderText: notificationScreenReaderText }))] })), children && (_jsx("div", Object.assign({ className: "sparky-c-utility-nav__item-panel", hidden: !isActive }, { children: children })))] })));
});
UtilityNavItem.displayName = 'UtilityNavItem';
//# sourceMappingURL=UtilityNavItem.js.map